/* Elwatanya — AOV behaviour: quantity ladder, cross-sell, cart recommendations.
   Everything here goes through Shopify's own cart endpoints; nothing invents a
   price and nothing bypasses the product form. */
(function () {
  'use strict';

  var THRESHOLD = 280000;         /* free shipping, in cents */
  var BAR_MIN   = 140000;         /* design rule: hide the bar below 1,400 EGP */
  var DISMISS_KEY = 'elwRecDismissed';

  function money(cents) { return Math.round(cents / 100).toLocaleString('en-US'); }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function postCart(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Ask the theme to re-render its cart UI. Dawn listens for this; if it is not
     there, the drawer still refreshes on its own next open. */
  function announceCartChange(cart) {
    try {
      var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) || window.PUB_SUB_EVENTS;
      var pub = (typeof publish === 'function' && publish) || window.publish;
      if (ev && ev.cartUpdate && typeof pub === 'function') {
        pub(ev.cartUpdate, { source: 'elw-aov', cartData: cart });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('elw:cart-changed', { detail: cart }));
  }

  /* ---------------- quantity ladder ---------------- */
  /* Every handler below is delegated from the document. Dawn replaces the whole
     buy box on each variant change, so listeners attached to individual tiers
     die with the old markup, and the replacements only work if something
     re-binds them. Re-binding used to depend on a debounced MutationObserver —
     and a debounce starves: the announcement bar mutates faster than the
     window, clearTimeout keeps resetting the timer, and the re-bind never runs.
     The ladder would render perfectly and be completely dead to the touch.
     Delegation means the new markup works without being re-bound at all. */

  function ladderOf(el) {
    var ladder = el.closest('[data-elw-ladder]');
    if (ladder) return ladder;
    var info = el.closest('.product__info-container');
    return info ? info.querySelector('[data-elw-ladder]') : null;
  }

  function tiersOf(ladder) { return [].slice.call(ladder.querySelectorAll('[data-elw-tier]')); }

  /* A tier total may be an approved offer below unit × qty. An off-tier quantity
     has no approved offer, so it falls back to unit × qty — the plain arithmetic
     the cart will do. A tier's discounted total must never carry over to a
     quantity that offer does not cover. */
  function paintLadder(ladder, btn, q) {
    var unit = parseInt(ladder.getAttribute('data-unit-price'), 10) || 0;
    var line = btn ? parseInt(btn.getAttribute('data-line-total'), 10) || 0 : unit * q;
    setText(ladder.querySelector('[data-elw-ladder-total]'), money(line) + ' ج');
    tiersOf(ladder).forEach(function (t) {
      var on = t === btn;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function tierFor(ladder, q) {
    var ts = tiersOf(ladder);
    for (var i = 0; i < ts.length; i++) {
      if ((parseInt(ts[i].getAttribute('data-qty'), 10) || 1) === q) return ts[i];
    }
    return null;
  }

  function qtyInputFor(ladder) {
    var info = ladder.closest('.product__info-container');
    return info ? info.querySelector('.quantity__input') : null;
  }

  /* The cross-sell follows the quantity. Every state is already rendered
     server-side from real variants; this only decides which one is visible, so
     no price is ever computed here. Quantities between tiers, or above the top
     one, fall to the highest state at or below them — a customer typing 7 gets
     the 5-roll companions. Below the smallest state, show the smallest. */
  function paintCrossSell(q) {
    var groups = [].slice.call(document.querySelectorAll('[data-elw-xs-group]'));
    if (!groups.length) return;
    var best = null, bestQ = -1, min = null, minQ = Infinity;
    groups.forEach(function (g) {
      var gq = parseInt(g.getAttribute('data-for-qty'), 10) || 1;
      if (gq <= q && gq > bestQ) { best = g; bestQ = gq; }
      if (gq < minQ) { min = g; minQ = gq; }
    });
    var winner = best || min;
    groups.forEach(function (g) { g.hidden = g !== winner; });
  }

  function selectTier(ladder, btn) {
    var q = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    paintLadder(ladder, btn, q);
    paintCrossSell(q);
    /* Drive the real quantity field so the product form submits this many.
       This is the only thing that decides what actually enters the cart. */
    var qtyInput = qtyInputFor(ladder);
    if (qtyInput && String(qtyInput.value) !== String(q)) {
      qtyInput.value = q;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-elw-tier]');
    if (!btn) return;
    var ladder = ladderOf(btn);
    if (ladder) selectTier(ladder, btn);
  });

  /* The quantity field stays editable, so it can walk away from the ladder.
     Follow it: highlight a tier where one matches, otherwise deselect and price
     the typed quantity plainly. */
  function syncFromQty(e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('quantity__input')) return;
    var ladder = ladderOf(input);
    if (!ladder) return;
    var q = parseInt(input.value, 10) || 1;
    paintLadder(ladder, tierFor(ladder, q), q);
    paintCrossSell(q);
  }
  document.addEventListener('input', syncFromQty);
  document.addEventListener('change', syncFromQty);

  /* First paint only: adopt the preselected tier and push its quantity into the
     form. Guarded so an unrelated repaint cannot reset a quantity the customer
     typed; if this is ever starved the cost is a late first paint, never a dead
     control. */
  function initLadder() {
    document.querySelectorAll('[data-elw-ladder]').forEach(function (ladder) {
      if (ladder.dataset.elwInit === '1') return;
      ladder.dataset.elwInit = '1';
      var pre = ladder.querySelector('[data-elw-tier].is-selected') || tiersOf(ladder)[0];
      if (pre) selectTier(ladder, pre);
    });
  }

  /* ---------------- cross-sell and recommendation adds ---------------- */
  /* Delegated for the same reason as the tiers: the cart drawer and the buy box
     are both re-rendered from the server, and per-button listeners do not
     survive that. These add real variants at their real prices — a dead button
     here is a silently lost sale, so it must not depend on a re-bind running. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-elw-xs-add], [data-elw-rec-add]');
    if (!btn) return;
    if (btn.getAttribute('data-state')) return;          /* already adding or added */
    var id = btn.getAttribute('data-variant-id');
    var q = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;
    btn.setAttribute('data-state', 'loading');
    postCart('cart/add.js', { items: [{ id: Number(id), quantity: q }] })
      .then(function () { return getCart(); })
      .then(function (cart) {
        btn.setAttribute('data-state', 'added');
        setText(btn, btn.getAttribute('data-added-label') || 'تمت الإضافة');
        if (cart) announceCartChange(cart);
      })
      .catch(function () {
        btn.removeAttribute('data-state');                /* let them retry */
      });
  });

  /* ---------------- cart recommendations ---------------- */
  function dismissed() {
    var out = dismissedMem.slice();
    try {
      JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]').forEach(function (r) {
        if (out.indexOf(r) === -1) out.push(r);
      });
    } catch (e) {}
    return out;
  }

  /* sessionStorage is not always writable — private-mode restrictions, blocked
     storage, an embedded context — and every access throws rather than failing
     quietly. Relying on it alone meant a dismissal silently did nothing and the
     card returned on the next repaint, which is exactly the nagging the design
     forbids. Memory holds it for this page, storage carries it across pages. */
  var dismissedMem = [];

  function dismiss(rule) {
    if (dismissedMem.indexOf(rule) === -1) dismissedMem.push(rule);
    try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(dismissed())); } catch (e) {}
  }

  /* The five-rule decision tree. First match wins; everything else is
     discarded, so the customer never sees two suggestions at once. Returns the
     id of the row to reveal, or null for "let them finish".

     The tape quantity always matches the bubble quantity already in the cart.
     Quantities between the mapped tiers fall to the highest tier at or below
     them, the same rule the product page uses, so a cart holding 7 rolls is
     treated as a 5-roll cart rather than a 1-roll one. */
  function tapeForBubbles(b) {
    if (b >= 5) return 'tape-36';
    if (b >= 3) return 'tape-12';
    return 'tape-4';
  }

  function chooseRule(cart, box) {
    var bubble = box.getAttribute('data-bubble-id');
    var stretch = box.getAttribute('data-stretch-id');
    var stretch6 = box.getAttribute('data-stretch6-id');
    var tape = box.getAttribute('data-tape-id');

    var qtyOf = function (id) {
      if (!id) return 0;
      return (cart.items || []).reduce(function (sum, i) {
        return String(i.product_id) === String(id) ? sum + (i.quantity || 0) : sum;
      }, 0);
    };

    var bubbles = qtyOf(bubble);
    var hasTape = qtyOf(tape) > 0;
    /* Either stretch product counts as "they already have stretch". */
    var hasStretch = qtyOf(stretch) > 0 || qtyOf(stretch6) > 0;

    if (!bubbles) return null;                 /* no bubbles, no map to work from */
    if (hasTape && hasStretch) return null;    /* nothing left worth suggesting */

    /* 1 · 2 · 3 — bubble on its own. Every quantity now takes the tape tier
       that matches it, single rolls included: 4 rolls at the approved 170 tier
       beats the stretch roll as an opening ask, and it is the same mapping
       rule 5 uses, so a cart cannot get two different answers for one
       quantity. This is what makes the tape-4 row reachable at all. */
    if (!hasTape && !hasStretch) return tapeForBubbles(bubbles);
    /* 4 — tape but no stretch. The 6-pack only once the order can absorb it. */
    if (hasTape && !hasStretch) return bubbles >= 10 ? 'stretch-6' : 'stretch-1';
    /* 5 — stretch but no tape: match the tape to the bubbles. */
    if (hasStretch && !hasTape) return tapeForBubbles(bubbles);
    return null;
  }

  /* The recommendation is held steady so it cannot change while the customer is
     reading it — but only for as long as the cart itself is unchanged. Repaints
     of the same cart keep the same card; an actual add/remove/quantity change
     is a deliberate action and re-opens the decision. Locking on first paint
     alone was wrong: an empty cart locked to "no recommendation" and never
     recovered once something was added. */
  var lockedRule, lockedSig;

  function cartSignature(cart) {
    return (cart.items || []).map(function (i) {
      return i.product_id + 'x' + i.quantity;
    }).join(',') + '|' + (cart.total_price || 0);
  }

  function paintRecs(cart) {
    var box = document.querySelector('[data-elw-recs]');
    if (!box || !cart) return;
    var cards = [].slice.call(box.querySelectorAll('[data-elw-rec]'));
    var skip = dismissed();

    var sig = cartSignature(cart);
    if (lockedRule === undefined || sig !== lockedSig) {
      lockedSig = sig;
      var r = chooseRule(cart, box);
      lockedRule = (r && skip.indexOf(r) === -1) ? r : null;
    }
    cards.forEach(function (c) {
      c.hidden = c.getAttribute('data-rec-id') !== lockedRule;
    });
  }

  /* Dismissing is delegated too — the drawer re-renders these cards. */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-elw-rec-dismiss]');
    if (!x) return;
    var card = x.closest('[data-elw-rec]');
    if (!card) return;
    dismiss(card.getAttribute('data-rec-id'));
    card.hidden = true;
    lockedRule = null;
    lockedSig = cartSignature({ items: [], total_price: -1 });  /* force re-evaluation next change */
  });

  /* Bar is hidden while the goal is far enough away to discourage (design rule). */
  function paintBarVisibility(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-elw-freeship]').forEach(function (bar) {
      if (!bar.closest('.cart-drawer__freeship, .cart__footer, .cart-notification')) return;
      bar.hidden = (cart.total_price || 0) < BAR_MIN;
    });
  }

  function refresh() {
    getCart().then(function (cart) {
      if (!cart) return;
      paintRecs(cart);
      paintBarVisibility(cart);
    }).catch(function () {});
  }

  function init() {
    initLadder();
    /* Products without a quantity ladder still carry the cross-sell table, and
       every group ships hidden. Nothing would reveal one, so open the smallest
       state. initLadder() overrides this where a ladder exists. */
    if (!document.querySelector('[data-elw-ladder]')) paintCrossSell(1);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('elw:cart-changed', function (e) {
    if (e.detail) { paintRecs(e.detail); paintBarVisibility(e.detail); } else refresh();
  });
  document.addEventListener('shopify:section:load', function () { lockedRule = undefined; init(); });

  /* A re-rendered drawer replaces the cards, so re-apply. Unlock when the
     drawer is closed so the next open can pick a fresh recommendation.

     Nothing here binds handlers any more — those are delegated and always live
     — so a starved run can no longer disable a control. It would still stall
     the repaint, though, so the flush is capped: a plain clearTimeout debounce
     never fires at all while the announcement bar mutates every 50ms. */
  var DEBOUNCE = 150, MAX_WAIT = 600;
  var t, firstQueued = 0;

  function flush() {
    firstQueued = 0;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active')) { lockedRule = undefined; lockedSig = undefined; }
    initLadder();
    refresh();
  }

  new MutationObserver(function () {
    var now = Date.now();
    if (!firstQueued) firstQueued = now;
    if (now - firstQueued >= MAX_WAIT) { clearTimeout(t); flush(); return; }
    clearTimeout(t);
    t = setTimeout(flush, DEBOUNCE);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
